import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { FormattedMessage } from "react-intl";
import AxionControls from "../../../components/controls/AxionControls";
import messages from "./messages";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { patchMachineAutocode } from "../../../fetchers/machine";
import { pushErrorMessage } from "../../../utils/notifications";

export default function AutoCodeDialog(props) {
    const [autocodeSetting, setAutocodeSetting] = useState({
            id: props.machineId,        
            autocodeStopReasonCodeId: 0,
            autocodeLength: 0
    });
    
    let stopReasonCodesForAutocoding = props.stopReasonCodes?.filter(x => x.canBeUsedForAutocoding === true);
            
    const handleChange = (event) => {
        const { id, name, value, type, checked } = event.target
        setAutocodeSetting(prev => {
            return {
                ...prev,
                [id ? id : name]: type === "checkbox" ? checked : value
            }
        })
    }

    const handleSave = () => {
        props.setShowBackdrop(true);
        patchMachineAutocode(autocodeSetting).then((response) => {
            props.refresh();
            props.setOpenPopup(false);
            props.setShowBackdrop(false);
        })
        .catch((error) => {
            console.log(error);
            props.setShowBackdrop(false);
            pushErrorMessage(`Could not set autocode.`);
        });
    }

    return (
        <>
            <Box
                sx={{
                    p: 1,
                    m: 1
                }}>
                <Box>
                    <AxionControls.AxionSelect
                        sx={{width: '50%', paddingRight: '6px'}}
                        options={stopReasonCodesForAutocoding.map((item) => {
                            return {
                                id: item.id,
                                title: item.name
                            }
                        }
                        )}
                        showNoneOption={false}
                        name="autocodeStopReasonCodeId"
                        label={<FormattedMessage {...messages.stopReasonCode} />}
                        value={autocodeSetting.autocodeStopReasonCodeId}
                        onChange={handleChange}
                    />
                    <AxionControls.AxionSelect
                        sx={{width: '50%', paddingRight: '6px'}}
                        options={[
                            {id: 30, title: '30 min'}, 
                            {id: 60, title: '1 h'}, 
                            {id: 90, title: '1 h 30 min'}, 
                            {id: 120, title: '2 h'}, 
                            {id: 180, title: '3 h'}, 
                            {id: 240, title: '4 h'}, 
                            {id: 300, title: '5 h'}, 
                            {id: 480, title: '8 h'}, 
                            {id: 720, title: '12 h'}, 
                            {id: 1080, title: '18 h'}, 
                            {id: 1440, title: '24 h'}, 
                        ]
                        }
                        showNoneOption={false}
                        name="autocodeLength"
                        label={<FormattedMessage {...messages.time} />}
                        value={autocodeSetting.autocodeLength}
                        onChange={handleChange}
                    />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
                    <InfoOutlinedIcon sx={{ marginRight: '8px', fontSize: 36 }} />
                    <Box sx={{ marginLeft: '10px' }}>
                        <FormattedMessage {...messages.autocodeInstructions} />
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    p: 1,
                    m: 1
                }}>
                <Box sx={{ flexDirection: 'row' }}>
                    <Button
                        sx={{ marginRight: '8px' }}
                        variant="contained"
                        onClick={handleSave}
                        disabled={autocodeSetting.autocodeStopReasonCodeId === 0 || autocodeSetting.autocodeLength === 0}
                        >
                        <FormattedMessage {...messages.save} />
                    </Button>
                    <Button
                        variant="contained"
                        disabled={!props.autocodeIsActive}
                        onClick={props.handleCancelAutocodeClick}
                        >
                        <FormattedMessage {...messages.cancelAutocode} />
                    </Button>
                </Box>
            </Box>
        </>
    );
}